module.exports = __webpack_public_path__ + "static/media/buy_finish_service_make_1.2c503eab.jpg";